export interface RoleObject {
  nameLabel: string; // Ditto translation string
  apiSlug: string; // A slug used in API
}

export const ADMINISTRATOR_ROLES: Readonly<RoleObject[]> = Object.freeze([
  {
    nameLabel: "role-super-administrator",
    apiSlug: "super-admin",
  },
  {
    nameLabel: "role-administrator",
    apiSlug: "admin",
  },
  {
    nameLabel: "role-read-only",
    apiSlug: "admin-ro",
  },
]);

export const displayRoleStringByApiSlug = (apiSlug: string): string => {
  const role = ADMINISTRATOR_ROLES.find((role) => role.apiSlug === apiSlug);
  return role?.nameLabel || "";
};
